import { z } from 'zod'

export const ContentfulPromotionBannerSchema = z.object({
  identifier: z.string(),
  internalName: z.string().optional(),
  bodyCopy: z.string(),
  badgeCopy: z.string().optional(),
  location: z.array(z.string()),
  product: z.enum(['Hotel', 'Car', 'Experience']),
  priority: z.number().int().min(0).max(6),
  promotionUniqueIdentifier: z.string().optional(),
})

export type ContentfulPromotionBannerType = z.infer<typeof ContentfulPromotionBannerSchema>
